import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    question: '¿Esto me ayuda a salir primero en Google?',
    answer: 'Sí. Google premia a los negocios que tienen una página web rápida y optimizada para celulares. Es el primer paso para dominar su zona y aparecer cuando los clientes buscan sus servicios.'
  }, {
    question: '¿Puedo cambiar mis precios o fotos después?',
    answer: 'Claro, como parte de su mantenimiento de $360 MXN, nosotros nos encargamos de cualquier cambio técnico, actualización de precios o fotos que necesite. Usted solo nos manda un WhatsApp y lo hacemos.'
  }, {
    question: '¿Cuánto tiempo tarda en estar lista?',
    answer: 'Entregamos su Conversion Lander completamente funcional en 72 horas hábiles a partir de que nos proporciona la información básica de su negocio (logo, servicios, datos de contacto).'
  }, {
    question: '¿Necesito saber de tecnología?',
    answer: 'Absolutamente no. Nosotros nos encargamos de toda la parte técnica (hosting, dominio, certificados de seguridad, código). Su única tarea será atender los mensajes de WhatsApp que le lleguen.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-nova-navy-dark relative border-t border-nova-navy-light/20" data-id="element-78">
      <div className="container mx-auto px-4 md:px-6" data-id="element-79">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-80">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-81">
            Preguntas Frecuentes
          </motion.h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-82">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-nova-navy-light/30 rounded-xl overflow-hidden bg-[#0a1120]" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-84">
                <span className="font-semibold text-white text-lg pr-8" data-id="element-85">
                  {faq.question}
                </span>
                <ChevronDown className={`text-nova-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-86" />
              </button>

              <AnimatePresence data-id="element-87">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-nova-navy-light/10 pt-4" data-id="element-89">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}